module.exports = __webpack_public_path__ + "media/video1.734906b4.mp4";